import {
  GET_QUESTIONNAIRES_LIST,
  GET_QUESTIONNAIRES_LIST_SUCCESS,
  GET_QUESTIONNAIRES_LIST_FAILURE,
} from 'store/QuestionnaireList/QuestionnaireListAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const questionnaireListDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_QUESTIONNAIRES_LIST:
      return { ...state, loading: true };
    case GET_QUESTIONNAIRES_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_QUESTIONNAIRES_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default questionnaireListDataReducer;
